module.exports = __webpack_public_path__ + "static/media/eye-off.a4379a92.svg";